import { render } from "./ProviderThingsRequiringAttention.vue?vue&type=template&id=d71fe096&scoped=true"
import script from "./ProviderThingsRequiringAttention.vue?vue&type=script&lang=js"
export * from "./ProviderThingsRequiringAttention.vue?vue&type=script&lang=js"

import "./ProviderThingsRequiringAttention.vue?vue&type=style&index=0&id=d71fe096&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d71fe096"]])

export default __exports__